import gql from 'graphql-tag';


const M_CREATE_CAMPAIGN = gql`
    mutation CreateCampaign($description: String, $title: String) {
        insert_campaigns(objects: {description: $description, title: $title}) {
        returning {
                title
                org_id
                id
                description
                created_at
                author_id
                updated_at
            }
        }
    }
`;

const M_UPDATE_CAMPAIGN = gql`
    mutation UpdateCampaign($campaign_id: uuid, $description: String, $title: String) {
        update_campaigns(where: {id: {_eq: $campaign_id}}, _set: {description: $description, title: $title}) {
            returning {
                title
                org_id
                id
                description
                created_at
                author_id
                updated_at
            }
        }
    }
`;



export {
    M_CREATE_CAMPAIGN,
    M_UPDATE_CAMPAIGN
}

